import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ChatGPTInterface = ({ onGenerate, isGenerating }) => {
  const [tone, setTone] = useState('professional');
  const [emphasis, setEmphasis] = useState('balanced');

  const toneOptions = [
    { value: 'professional', label: 'Professional', icon: 'Briefcase' },
    { value: 'confident', label: 'Confident', icon: 'Zap' },
    { value: 'approachable', label: 'Approachable', icon: 'Heart' }
  ];

  const emphasisOptions = [
    { value: 'technical', label: 'Technical Skills', icon: 'Code' },
    { value: 'leadership', label: 'Leadership', icon: 'Users' },
    { value: 'balanced', label: 'Balanced', icon: 'Scale' }
  ];

  const handleGenerate = () => {
    onGenerate({ tone, emphasis });
  };

  return (
    <div className="bg-white rounded-2xl p-4 md:p-6 border border-[#E5E7EB]">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center bg-gradient-to-br from-[#06B6D4] to-[#0891B2]">
          <Icon name="Sparkles" size={20} color="#FFFFFF" />
        </div>
        <div>
          <h3 className="text-base md:text-lg font-semibold text-[#111827]">AI Profile Generator</h3>
          <p className="text-xs md:text-sm text-[#6B7280]">Customize your anonymous profile</p>
        </div>
      </div>
      <div className="space-y-4 md:space-y-6">
        <div>
          <label className="block text-sm md:text-base font-medium text-[#111827] mb-3">Writing Tone</label>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-3">
            {toneOptions?.map((option) => (
              <button
                key={option?.value}
                onClick={() => setTone(option?.value)}
                className={`flex items-center gap-2 md:gap-3 p-3 md:p-4 rounded-xl border-2 transition-all duration-250 ${
                  tone === option?.value
                    ? 'border-[#5B2DFF] bg-[#5B2DFF]/5'
                    : 'border-[#E5E7EB] hover:border-[#5B2DFF]/30'
                }`}
              >
                <Icon name={option?.icon} size={18} color={tone === option?.value ? '#5B2DFF' : '#6B7280'} />
                <span className={`text-sm md:text-base font-medium ${
                  tone === option?.value ? 'text-[#5B2DFF]' : 'text-[#111827]'
                }`}>
                  {option?.label}
                </span>
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm md:text-base font-medium text-[#111827] mb-3">Profile Emphasis</label>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-3">
            {emphasisOptions?.map((option) => (
              <button
                key={option?.value}
                onClick={() => setEmphasis(option?.value)}
                className={`flex items-center gap-2 md:gap-3 p-3 md:p-4 rounded-xl border-2 transition-all duration-250 ${
                  emphasis === option?.value
                    ? 'border-[#5B2DFF] bg-[#5B2DFF]/5'
                    : 'border-[#E5E7EB] hover:border-[#5B2DFF]/30'
                }`}
              >
                <Icon name={option?.icon} size={18} color={emphasis === option?.value ? '#5B2DFF' : '#6B7280'} />
                <span className={`text-sm md:text-base font-medium ${
                  emphasis === option?.value ? 'text-[#5B2DFF]' : 'text-[#111827]'
                }`}>
                  {option?.label}
                </span>
              </button>
            ))}
          </div>
        </div>

        <Button
          variant="default"
          size="lg"
          fullWidth
          loading={isGenerating}
          iconName="Sparkles"
          iconPosition="left"
          onClick={handleGenerate}
        >
          {isGenerating ? 'Generating Profile...' : 'Generate Anonymous Profile'}
        </Button>

        <div className="flex items-start gap-2 p-3 md:p-4 bg-[#F6F7FB] rounded-xl">
          <Icon name="Info" size={16} color="#5B2DFF" className="flex-shrink-0 mt-0.5" />
          <p className="text-xs md:text-sm text-[#6B7280]">
            AI will create a compelling professional summary while automatically removing any identifying information like company names, locations, or personal details.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChatGPTInterface;